jQuery(function($){
  // HEADER  UX (Desktop) ///////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  let openedMenu;

  // $('.nav-desktop nav.menu--main ul li').first().remove();

  // Show nav dropdown menu when hover over
  $('.nav-desktop nav.menu--main ul li.menu-item--expanded a:not(.nav-desktop nav.menu--main ul li.menu-item--expanded ul li a)').on('mouseenter', function(){
    $(this).next().show();
    openedMenu = $(this).next();
  });

  // Hide nav dropdown when a nav item without dropdown is hover over
  $('.nav-desktop nav.menu--main ul li a:not(.nav-desktop nav.menu--main ul li.menu-item--expanded a, .nav-desktop nav.menu--main ul li.menu-item--expanded ul li a)').on('mouseenter', function(){
    if (openedMenu === undefined) { return; }
    openedMenu.hide();
  });

  // Hide nav dropdown when mouse is hover out
  $('.nav-desktop nav.menu--main ul li.menu-item--expanded ul').hover(function () {
    $(this).show();
  }, function () {
    $(this).hide();
  });

  // Tabs switching handler for Explore Menu
  $('.explore-menu--nav li a:not(.explore-menu--nav li.menu-item--expanded .menu a)').on('mouseenter', function(){
    if (!$(this).parent().hasClass('menu-item--expanded')) {
      $('.explore-menu--nav li.menu-item--expanded .menu').fadeOut();
      $('.explore-menu--nav li.menu-item--expanded a:not(.explore-menu--nav li.menu-item--expanded .menu a)').removeClass('active');
      return;
    }

    if ($(this).hasClass('active')) { return }

    $('.explore-menu--nav li.menu-item--expanded .menu').fadeOut();
    $(this).next().fadeIn();

    $('.explore-menu--nav li.menu-item--expanded a:not(.explore-menu--nav li.menu-item--expanded .menu a)').removeClass('active');
    $(this).addClass('active');
  });

  $('.explore-menu-wrapper nav.menu--explore .menu li.menu-item--expanded a').on('click', function(e){
    const elm = $(this);
    const href = elm.attr('href');

    if (href === '' || href === '#') {
      e.preventDefault();
    }
  });

  // HEADER  UX (Desktop) ///////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // HEADER  UX (Mobile) ////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $('.nav-mobile nav ul li.menu-item--active-trail a').addClass('active');

  $('#button-open-mobile-menu').on('click', function(){
    $('#mobile-menu').fadeIn();
  });

  $('#button-close-mobile-menu').on('click', function(){
    $('#mobile-menu').fadeOut();
  });

  $('.nav-mobile nav ul li.menu-item--expanded a:not(.nav-mobile nav ul li.menu-item--expanded ul li a)').on('click', function(e) {
    e.preventDefault();

    const elm = $(this);
    const href = elm.attr('href');

    if (href === '' || href === '#') {
      e.preventDefault();
    }

    if (elm.hasClass('active')) {
      elm.removeClass('active');
      elm.next().hide();
    } else {
      elm.addClass('active');
      elm.next().show();
    }
  });

  $("#explore-menu").on("click", function (e) {
    if (e.target === this) {
      $(this).fadeOut();
    }
  });

  // HEADER  UX (Mobile) ////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END
});
